import React from "react";
import Background from "../Background";
import NotificationTable from "./NotificationTable";

const NotificationManagement = () => {
    return (
        <Background heading={"Notification Management"} key="user-management">
            <NotificationTable />
        </Background>
    );
};

export default NotificationManagement;
